import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { Table, Input, Select, Modal, Tooltip } from "antd";
// import Map from "../../ui/map_full_detail";
import Api from "../../services/ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
import { Link } from "react-router-dom";
import { VList } from "virtuallist-antd";
import ModalSuccess from "../../components/Modal_Success";
// const { Option } = Select;


class Mahistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Ma History",
      tab: [{ text: "Job Complete" }, { text: "Job Cancel" }],
      active: 0,
      options: [
        { value: 1, text: "Job ID" },
        { value: 2, text: "Inform Date" },
      ],
      current_option: 1,
      columns: [
        {
          title: "Job ID",
          dataIndex: "",
          key: "",
          render: (item) => (
            <button
              onClick={() =>
                this.setCookies(item.job_id, item.job_progress_id, item.job_type_id)
              }
              // href="#"
              className="c-blue text-underline"
            >
              {item.job_no}
            </button>
          ),
          sorter: (a, b) => a.job_no.localeCompare(b.job_no),
        },
        {
          title: "Job Category",
          render: (item) =>
            !item.job_category_name ? "-" : item.job_category_name,
          key: "job_category_name",
          // defaultSortOrder: "descend",
          sorter: (a, b) =>
            (a.job_category_name ? a.job_category_name.length : "-") -
            (b.job_category_name ? b.job_category_name.length : "-"),
        },
        {
          title: "Job Type",
          render: (item) =>
            !item.job_type_name ? "-" : item.job_type_name,
          key: "job_type_name",
          // defaultSortOrder: "descend",
          sorter: (a, b) =>
            (a.job_type_name ? a.job_type_name.length : "-") -
            (b.job_type_name ? b.job_type_name.length : "-"),
        },
        {
          title: "Asset Code",
          key: "asset_code",
          ellipsis: {
            showTitle: false,
          },
          width: 120,
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.asset_code ? "-" : item.asset_code}
            >
              {!item.asset_code ? "-" : item.asset_code}
            </Tooltip>
          ),
          sorter: (a, b) =>
            (a.asset_code ? a.asset_code.length : " ") -
            (b.asset_code ? b.asset_code.length : " "),
        },
        {
          title: "Asset Name",
          key: "asset_name",
          render: (item) => {
            return (
              <Tooltip
                placement="topLeft"
                title={!item.asset_name ? "-" : item.asset_name}
              >
                {" "}
                {!item.asset_name ? "-" : item.asset_name}{" "}
              </Tooltip>
            );
          },
          sorter: (a, b) =>
            (a.asset_name ? a.asset_name.length : "-") -
            (b.asset_name ? b.asset_name.length : "-"),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Inform Date",
          key: "emp_inform_date",
          render: (item) => {
            return !item.emp_inform_date
              ? "-"
              : this.dateFormat(item.emp_inform_date);
          },
          sorter: (a, b) => a.emp_inform_date.localeCompare(b.emp_inform_date),
        },
        {
          title: "Inform Detail",
          key: "inform_detail",
          sorter: (a, b) =>
            (a.inform_detail ? a.inform_detail.length : " ") -
            (b.inform_detail ? b.inform_detail.length : " "),
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip
              placement="topLeft"
              title={!item.inform_detail ? "-" : item.inform_detail}
            >
              {!item.inform_detail ? "-" : item.inform_detail}
            </Tooltip>
          ),
        },
        {
          title: "Asset Type",
          render: (item) => (!item.asset_type ? "-" : item.asset_type),
          key: "asset_type",
          sorter: (a, b) => a.asset_type - b.asset_type,
        },
        {
          title: "Priority",
          dataIndex: "priority_level",
          key: "priority_level",
          render: (item) => (
            <div>
              {item == "1" ? (
                <span style={{ color: "#618817" }}>Low</span>
              ) : null}
              {item == "2" ? (
                <span style={{ color: "#E8CD00" }}>Normal</span>
              ) : null}
              {item == "3" ? (
                <span style={{ color: "#E09307" }}>High</span>
              ) : null}
            </div>
          ),
          sorter: (a, b) => a.priority_level - b.priority_level,
        },
        {
          title: "Status",
          key: "job_status",
          sorter: (a, b) =>
            (a.job_status ? a.job_status.length : "-") -
            (b.job_status ? b.job_status.length : "-"),
          render: (item) => (
            <span className="badge badge-pill badge-light font-thai-b font14">
              {/* {item.job_status === 1 || item.job_status === "1" ? "Cancel": null} */}

              {(item.job_status === 999 || item.job_status === "999") &&
                this.state.active === 0
                ? item.job_status_name
                : "Cancel"}
            </span>
          ),
        },
        {
          title: "Action",
          key: "job_status",
          render: (item) => (

            item.job_status === 999 ?
              <a onClick={() =>
                this.setState({
                  visible_cancel: true,
                  data_cancel: item,
                })
              }
              >
                <img
                  src={Api.absoluteUrl("/icon/icon_cancel.svg")}
                  className="mr-2"
                />

                Cancel
              </a>
              : "-"
          ),
        },
      ],
      data: [],
      data_cancel: [],
      filterTable: null,
      job_category_list: [],
      loading: false,
      selected_job_cat: null,
      visible_cancel: false,
      modalstatus: false
    };
  }

  async componentDidMount() {
    document.title = this.state.title;
    // await this.setState({
    //   loading: true,
    // })

    Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1
    }).then((values) => {
      if (values.data.result.code.toLowerCase() == "p") {
        this.setState({
          job_category_list: values.data.data.result_data
        })
      }
    })

    // const getalljob = await Api.post("v4/get_ma_list_job_V2", {
    //   i_select: null,
    //   job_status: 999,
    //   category_id: null,
    //   select_date: null,
    //   job_type_id: null,
    //   prority_id: null,
    //   username: Cookies.get("username"),
    //   company_id: Cookies.get("companyid"),
    //   operator_id: Cookies.get("operator_id"),
    //   project_id: Cookies.get("project_id"),
    //   sql_where: "",
    //   create_by: Cookies.get("username"),
    // });
    // const getalljob_cancel = await Api.post("get_ma_list_job_V2_Cancel", {
    //   i_select: null,
    //   job_status: null,
    //   category_id: null,
    //   select_date: null,
    //   job_type_id: null,
    //   prority_id: null,
    //   username: Cookies.get("username"),
    //   company_id: Cookies.get("companyid"),
    //   operator_id: Cookies.get("operator_id"),
    //   project_id: Cookies.get("project_id"),
    //   sql_where: "",
    //   create_by: Cookies.get("username"),
    // });
    await this.setState({
      // data: getalljob.data.data.result_ma_job_list,
      // data_cancel: getalljob_cancel.data.data.result_ma_job_list_cancel,
      loading: false,
    });
  }

  onChangFilterJobCat = async (values) => {
    const { active } = this.state;
    await this.setState({
      loading: true,
    })
    if (active === 0 && values != undefined) {
      const getalljob = await Api.post("v4/get_ma_list_job_V2", {
        i_select: null,
        job_status: 999,
        category_id: values,
        select_date: null,
        job_type_id: null,
        prority_id: null,
        username: Cookies.get("username"),
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        sql_where: "",
        create_by: Cookies.get("username"),
      });
      await this.setState({
        data: getalljob.data.data.result_ma_job_list,
        loading: false,
        selected_job_cat: values
      });
    } else if (active === 1 && values != undefined) {

      const getalljob_cancel = await Api.post("get_ma_list_job_V2_Cancel", {
        i_select: null,
        job_status: null,
        category_id: values,
        select_date: null,
        job_type_id: null,
        prority_id: null,
        username: Cookies.get("username"),
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        sql_where: "",
        create_by: Cookies.get("username"),
      });
      await this.setState({
        data_cancel: getalljob_cancel.data.data.result_ma_job_list_cancel,
        loading: false,
        selected_job_cat: values
      });
    } else {
      await this.setState({
        data_cancel: [],
        data: [],
        loading: false,
        selected_job_cat: null,

      });
    }
  }

  dateFormat(item) {
    return !item ? "-" : moment(item).format("DD/MM/YYYY HH:mm");
  }

  onView(id) {
    this.setState({
      visible: true,
      asset_id: id,
    });
  }

  search = (value) => {
    const { data, data_cancel, tab } = this.state;
    var index = 0;
    var setdata = [];
    var obj = {};
    if (this.state.active === 0) {
      for (let i = 0; i < data.length; i++) {
        for (const [key, value] of Object.entries(data[i])) {
          // if (`${key}` !== "inform_job_id") {
          if (!value) {
            obj[`${key}`] = "-";
          } else {
            obj[`${key}`] = `${value}`;
          }
          // }
        }
        setdata.push(obj);
        setdata.push(index++);
        obj = {};
      }
    } else {
      for (let i = 0; i < data_cancel.length; i++) {
        for (const [key, value] of Object.entries(data_cancel[i])) {
          // if (`${key}` !== "inform_job_id") {
          if (value == null || value == undefined) {
            obj[`${key}`] = "-";
          } else {
            obj[`${key}`] = `${value}`;
          }
          // }
        }
        setdata.push(obj);
        setdata.push(index++);
        obj = {};
      }
    }

    const filterTable = setdata.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );

    this.setState({ filterTable });
  };

  dataOption() {
    if (this.state.active === 0) {
      return this.state.filterTable == null
        ? this.state.data
        : this.state.filterTable;
    } else {
      return this.state.filterTable == null
        ? this.state.data_cancel
        : this.state.filterTable;
    }
  }

  CancelAssign = async () => {
    var dataset = [];
    var status_cancel = [];
    if (this.state.data_cancel.length === undefined) {
      dataset.push({
        company_id: Cookies.get("companyid"),
        operator_id: this.state.data_cancel.operator_id,
        project_id: this.state.data_cancel.project_id,
        job_id: this.state.data_cancel.job_id,
        job_progress_id: this.state.data_cancel.job_progress_id,
        location_lat: "",
        location_long: "",
        create_by: Cookies.get("username"),
      })
    }
    else {
      for (let i = 0; i < this.state.data_cancel.length; i++) {
        if (this.state.data_cancel[i].job_progress_id === null) {
          status_cancel.push(this.state.data_cancel[i]);
        }
        else {
          dataset.push({
            company_id: Cookies.get("companyid"),
            operator_id: this.state.data_cancel[i].operator_id,
            project_id: this.state.data_cancel[i].project_id,
            job_id: this.state.data_cancel[i].job_id,
            job_progress_id: this.state.data_cancel[i].job_progress_id,
            location_lat: "",
            location_long: "",
            create_by: Cookies.get("username"),
            job_no: this.state.data_cancel[i].job_no
          })
        }
      }
    }
    this.setState({ status_cancel })
    const CancelAssign = await Api.post("update_oper_job_cancel_list", dataset);
    if (CancelAssign.data.result.code === "P") {
      if (status_cancel.length > 0) {
        this.setState({
          display_status_cancel: dataset,
          visible_cancel: false,
          modalstatus: true
        })
      } else {
        this.setState({
          // display_status_cancel : dataset , 
          visible_cancel: false,
          modalstatus: true
        })
      }

    } else {
      alert("Error");
    }
  };

  async selectTab(index) {
    const { active, selected_job_cat } = this.state;
    await this.setState({
      loading: true,
    })

    if (index === 0 && selected_job_cat != null) {
      const getalljob = await Api.post("v4/get_ma_list_job_V2", {
        i_select: null,
        job_status: 999,
        category_id: selected_job_cat,
        select_date: null,
        job_type_id: null,
        prority_id: null,
        username: Cookies.get("username"),
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        sql_where: "",
        create_by: Cookies.get("username"),
      });
      await this.setState({
        data: getalljob.data.data.result_ma_job_list,
        loading: false,
      });
    } else if (index === 1 && selected_job_cat != null) {

      const getalljob_cancel = await Api.post("get_ma_list_job_V2_Cancel", {
        i_select: null,
        job_status: null,
        category_id: selected_job_cat,
        select_date: null,
        job_type_id: null,
        prority_id: null,
        username: Cookies.get("username"),
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        sql_where: "",
        create_by: Cookies.get("username"),
      });
      await this.setState({
        data_cancel: getalljob_cancel.data.data.result_ma_job_list_cancel,
        loading: false,
      });
    }

    await this.setState({
      active: index,
      filterTable: null,
    })
    await this.setState({
      loading: false,
    })
  }

  setCookies(job_id, job_progress_id, job_type_id) {
    var dataFullDetail = this.dataOption();
    Cookies.set("job_id", job_id);
    Cookies.set("job_progress_id", job_progress_id);
    Cookies.set("job_type_id", job_type_id);
    localStorage.setItem("dataNext", JSON.stringify(dataFullDetail));
    localStorage.setItem("jobID_Back", dataFullDetail[0]["job_id"]);
    localStorage.setItem("jobID_Last", dataFullDetail[dataFullDetail.length - 1]["job_id"])

    setTimeout(function () {
      window.location.assign("/MaxiOperation/full_detail_job");
    }, 100);
  }
  render() {
    const {
      title,
      active,
      tab,
      data,
      current_option,
      options,
      columns,
      filterTable,
      job_category_list
    } = this.state;
    return (
      <LayoutOperation active={2}>
        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-3">
                <img
                  src={Api.absoluteUrl("/icon/asset_list_white.svg")}
                  className="mr-3"
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                  {title}
                </h2>
              </div>
              <div className="col-6"></div>
              <div className="col-3 text-right">
                <Link to="/" className="c-white font-mont-m font12">
                  <img
                    src={Api.absoluteUrl("/icon/map.svg")}
                    className="mr-1"
                  />
                  Map
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-between my-3">
              <div>
                <div className="d-flex">
                  {/* <div className="mr-4">
                    <Input.Group compact>
                      <Select placeholder="Asset Group Type"></Select>
                      <Select placeholder="Asset Type"></Select>
                    </Input.Group>
                  </div> */}
                  <div>
                    <Input.Group compact>
                      {/* <Select
                        value={current_option}
                        style={{ width: "180px" }}
                        onChange={this.handleOptionSearch}
                      >
                        {options.map((item, index) => (
                          <Option key={index} value={item.value}>
                            {item.text}
                          </Option>
                        ))}
                      </Select> */}
                      <Select
                        name="jobcat"

                        placeholder="Please select job category to filter"
                        style={{ width: "335px", marginRight: "1rem" }}
                        // className="dropdrowtype font-thai-r"
                        onChange={this.onChangFilterJobCat}
                      >
                        {job_category_list.map((data, index) => (
                          <Select.Option
                            key={index}
                            value={data.job_category_id}
                          >
                            {data.job_category_name}
                          </Select.Option>
                        ))}
                      </Select>
                      <Input.Search
                        placeholder="Search"
                        onSearch={this.search}
                        style={{ width: "335px", marginRight: "1rem" }}
                        enterButton
                      />

                    </Input.Group>
                  </div>
                </div>
              </div>
              {/* <div>
                <Link to="/addjob" className="btn btn-warning">
                  <img
                    src={Api.absoluteUrl("/icon/add_job.svg")}
                    width="14"
                    className="mr-2"
                  />
                  Add Asset
                </Link>
              </div> */}
            </div>
            <div className="card-table-ma">
              <ul className="nav">
                {tab.map((item, index) => (
                  <li key={index} className="nav-item font12 font-mont-sb mr-1">
                    <a
                      className={
                        active === index ? "nav-link active" : "nav-link"
                      }
                      onClick={() =>
                        this.selectTab(index)
                      }
                    >
                      {item.text}
                    </a>
                  </li>
                ))}
              </ul>
              <div style={{ padding: "20px" }}>
                <Table
                  rowKey="job_id"
                  columns={columns}
                  loading={this.state.loading}
                  dataSource={this.dataOption()}
                  scroll={{ x: 3000, y: 500 }}
                  components={VList({
                    height: 500,
                    // vid: "first"
                  })}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal
          title={null}
          centered
          visible={this.state.visible_cancel}
          footer={null}
          closable={false}
        >
          <div className="text-center">
            <img
              src={Api.absoluteUrl("/img/modal_success.svg")}
              className="img-fluid"
            />
            <h3 className="font-mont-sb font18 c-blue mt-3">
              Cancel Assign Job {this.state.data_cancel.job_no}
            </h3>
            <button
              className="btn-secondary"
              onClick={() => this.setState({ visible_cancel: false })}
            >
              Close
            </button>
            <button
              className="btn-primary"
              onClick={() => this.CancelAssign()}
            >
              {/* {this.state.visible_success === false
              ? window.location.reload()
              : null} */}
              Ok
            </button>
          </div>
        </Modal>

        {this.state.modalstatus ? (
          <ModalSuccess
            status="Successfully"
            path_location="/MaxiOperation/ma_history"
          />
        ) : null}
      </LayoutOperation>
    );
  }
}

export default Mahistory;
